import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { NgxChartsModule } from '@swimlane/ngx-charts';

export const routes = [
  { path: '', component: DashboardComponent, pathMatch: 'full' }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    PerfectScrollbarModule,
    NgxChartsModule
  ],
  declarations: [
    DashboardComponent
      
  ]
})

export class DashboardModule { }
 


// WEBPACK FOOTER //
// E:/sachin/Project/Masterly_Solutions/Project_HRMS/Hrms_Developer/hrms/Peerless.HRMS.WebUI.EmployeePortal/src/app/pages/dashboard/dashboard.module.ts